import { NgModule } from '@angular/core';

import { ButtonsComponent } from './buttons.component';
import { CommonModule } from '@angular/common';
import { ButtonsDirective } from './buttons.directive';

@NgModule({
  imports: [CommonModule],
  exports: [ButtonsComponent],
  declarations: [ButtonsComponent, ButtonsDirective],
})
export class ButtonsModule {}
